<template>
  <div style="text-align: center">
    <div>
      <h2 class="mb-4">Your order is confirmed!</h2>
    </div>
    <div>
      <img
        src="../../../assets/images/bag_ok.svg"
        width="150"
        class="mb4 mt-4"
      />
      <p class="mt-3" style="color: rgb(74, 74, 74)">
        <el-icon name="tickets"></el-icon> Order #:
        {{ orderConfirmationNumber }}
      </p>
    </div>
    <div style="margin-top: 20px">
      <div v-if="isConfirmedOrder">
        <div class="confirmation-message">
          <i class="el-icon-success mr-2"></i
          ><strong>Your payment was successful.</strong>
          <p class="mt-3">A receipt has been sent to {{ strUserEmail }}</p>
          <p class="mt-3">Thanks for shopping with us!</p>
        </div>
      </div>
      <div v-else>
        <div class="confirmation-message">
          <i class="el-icon-info mr-2"></i
          ><strong>Your payment request is still processing.</strong>
          <p class="mt-3">
            We’ll send your receipt and as soon it's been confirmed
          </p>
          <p class="mt-3">Thanks for shopping with us!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    isConfirmedOrder: {
      type: Boolean,
      required: true
    },
    orderConfirmationNumber: {
      type: String,
      required: true
    },
    customerEmail: {
      type: String,
      required: true
    }
  },
  computed: {
    strUserEmail() {
      let message;
      if (this.customerEmail) {
        message = this.customerEmail;
      } else {
        message = "your email address";
      }
      return message;
    }
  }
};
</script>
<style>
.confirmation-message {
  padding: 20px;
  background-color: rgb(230, 255, 250);
  border-bottom-color: rgb(56, 178, 172);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-style: solid;
  border-bottom-width: 0px;
  border-image-outset: 0px;
  border-left-color: rgb(56, 178, 172);
  border-left-style: solid;
  border-left-width: 0px;
  border-right-color: rgb(56, 178, 172);
  border-right-style: solid;
  border-right-width: 0px;
  border-top-color: rgb(56, 178, 172);
  border-top-style: solid;
  border-top-width: 4px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
    rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  box-sizing: border-box;
  color: rgb(35, 78, 82);
  font-size: 16px;
  line-height: 26px;
}
</style>
